/**
 * API and Stripe configuration
 */

// Stripe publishable key (set REACT_APP_STRIPE_PUBLISHABLE_KEY in env / .env.local)
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';

// Base URL for serverless API (DO Serverless)
// vpn-stripe-checkout may use a different namespace if deployed separately.
// Get URL: doctl serverless function get vpn/vpn-stripe-checkout --url
const API_BASE =
  process.env.REACT_APP_API_BASE ||
  'https://faas-nyc1-2ef2e6cc.doserverless.co/api/v1/web/fn-a14af637-c32b-4663-8e91-3fbcdf60921a';

export const CREATE_CHECKOUT_SESSION_URL =
  process.env.REACT_APP_STRIPE_CHECKOUT_URL ||
  `${API_BASE}/vpn/vpn-stripe-checkout.json`;
export const VPN_SIGNUP_URL = `${API_BASE}/vpn/vpn-signup`;
export const VPN_LOGIN_URL = `${API_BASE}/vpn/vpn-login`;
export const VPN_EMAIL_CREDS_URL = `${API_BASE}/vpn/vpn-email-creds`;
export const VPN_FORGOT_PASSWORD_URL = `${API_BASE}/vpn/vpn-forgot-password`;
export const VPN_GEOIP_URL =
  process.env.REACT_APP_VPN_GEOIP_URL || `${API_BASE}/vpn/geoip.json`;
